import React from 'react';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: FaFacebook, href: 'https://facebook.com/rasohaacademy', label: 'Facebook' },
    { icon: FaTwitter, href: 'https://twitter.com/rasohaacademy', label: 'Twitter' },
    { icon: FaInstagram, href: 'https://instagram.com/rasohaacademy', label: 'Instagram' },
    { icon: FaLinkedin, href: 'https://linkedin.com/company/rasohaacademy', label: 'LinkedIn' },
  ];

  return (
    <footer className="bg-gray-900 dark:bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* School Info */}
          <div className="space-y-4">
                           <div className="flex items-center">
                 <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-purple-600 rounded-lg flex items-center justify-center mr-3 shadow-lg">
                   <span className="text-white font-bold text-lg">R</span>
                 </div>
                 <h3 className="text-xl font-bold">Rasoha Academy</h3>
               </div>
            <p className="text-gray-300 text-sm">
              Empowering students with quality education and fostering a culture of excellence, 
              innovation, and community service.
            </p>
          </div>

          {/* Contact Information */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Contact Information</h4>
            <div className="space-y-2 text-sm text-gray-300">
              <div className="flex items-center">
                <FaMapMarkerAlt className="w-4 h-4 mr-2 text-blue-400" />
                <span>123 Education Street, City, State 12345</span>
              </div>
              <div className="flex items-center">
                <FaPhone className="w-4 h-4 mr-2 text-blue-400" />
                <span>(555) 123-4567</span>
              </div>
              <div className="flex items-center">
                <FaEnvelope className="w-4 h-4 mr-2 text-blue-400" />
                <span>info@rasohaschool.edu</span>
              </div>
            </div>
          </div>

          {/* Social Media */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Follow Us</h4>
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="w-10 h-10 bg-gray-700 hover:bg-blue-600 rounded-full flex items-center justify-center transition-colors duration-200"
                  aria-label={social.label}
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-300">
              © {currentYear} Rasoha School. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="/privacy" className="text-sm text-gray-300 hover:text-blue-400 transition-colors duration-200">
                Privacy Policy
              </a>
              <a href="/terms" className="text-sm text-gray-300 hover:text-blue-400 transition-colors duration-200">
                Terms of Service
              </a>
              <a href="/accessibility" className="text-sm text-gray-300 hover:text-blue-400 transition-colors duration-200">
                Accessibility
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 